import PropTypes from 'prop-types'
import {useMemo} from 'react'

function splitCountryLang(input) {
    const lastSpaceIndex = input.lastIndexOf(' ')
    const country = input.substring(0, lastSpaceIndex)
    const lang = input.substring(lastSpaceIndex + 1)
    return {country, lang}
}

function transformRegionData(regionData) {
    if (!regionData) {
        return null
    }
    return {
        region: regionData.title,
        countries: regionData.locales.reduce((acc, locale) => {
            const countryCode = locale.locale_iso_code?.split('-')[1]?.toUpperCase()
            const {country, lang} = splitCountryLang(locale.redirect.title)
            if (countryCode) {
                acc[countryCode] = acc[countryCode] || []
                acc[countryCode].push({
                    country,
                    lang,
                    url: locale.redirect.href,
                })
            }
            return acc
        }, {}),
    }
}

const useCountries = (data) => {
    const countries = useMemo(() => {
        return data
            ? [
                  transformRegionData(data?.europe),
                  transformRegionData(data?.africa_middle_east),
                  transformRegionData(data?.americas),
                  transformRegionData(data?.asia_pacific),
              ]
            : []
    }, [data])

    return countries
}

useCountries.propTypes = {
    data: PropTypes.object,
}

export default useCountries
